import React, { useContext, useState, useEffect } from 'react';
import { __assign } from '../_virtual/_tslib.js';
import { ExperimentContext } from '../context/ExperimentClient.js';
import 'hoist-non-react-statics';

var Experiment = function (_a) {
    var id = _a.id, defaultTreatment = _a.default, attributes = _a.attributes, options = _a.options, children = _a.children;
    var client = useContext(ExperimentContext);
    // Resolve the experiment treatment for the given viewer + attributes.
    //
    // This is stateful because the initial call to `.treatment()` may return without a `result`
    //   field, instead exposing a Promise. In that case, we will wait for the Promise to resolve
    //   and update the state.
    var _b = useState(client.treatment({
        experiment: id,
        defaultTreatment: defaultTreatment,
        attributes: attributes,
        options: options
    })), treatment = _b[0], setTreatment = _b[1];
    // If the experiment starts in a loading state, we need to update the state once the promise
    //   is resolved.
    useEffect(function () {
        if (!treatment.result) {
            treatment.promise.then(function (result) {
                setTreatment(__assign(__assign({}, treatment), { result: result }));
            });
        }
    }, []);
    var result = treatment.result;
    var loading = !treatment.result;
    if (typeof children === 'function') {
        return children({
            result: treatment.result,
            loading: loading
        });
    }
    if (loading) {
        return null;
    }
    var childrenAsArray = React.Children.toArray(children);
    var bucketedTreatmentChild = childrenAsArray.find(function (child) {
        return child.props &&
            child.props.id === result;
    });
    var defaultTreatmentChild = childrenAsArray.find(function (child) {
        return child.props &&
            child.props.id === defaultTreatment;
    });
    if (!defaultTreatmentChild) {
        throw new Error("The default variation \"" + defaultTreatment + "\" is missing in the JSX for experiment " + id);
    }
    if (options && options.skip) {
        return defaultTreatmentChild;
    }
    return bucketedTreatmentChild || defaultTreatmentChild;
};

export { Experiment };
//# sourceMappingURL=Experiment.js.map
